import { render, staticRenderFns } from "./advMessReturn.vue?vue&type=template&id=49be806e&"
import script from "./advMessReturn.vue?vue&type=script&lang=js&"
export * from "./advMessReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49be806e')) {
      api.createRecord('49be806e', component.options)
    } else {
      api.reload('49be806e', component.options)
    }
    module.hot.accept("./advMessReturn.vue?vue&type=template&id=49be806e&", function () {
      api.rerender('49be806e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/advMessReturn.vue"
export default component.exports